<div class="relative">
  <button
    #toggleButton
    type="button"
    id="a11y-menu-button"
    aria-haspopup="true"
    [attr.aria-expanded]="menuOpen"
    aria-controls="a11y-menu"
    (click)="toggleMenu($event)"
  >
    <span class="sr-only">{{ "HEADER.ACCESSIBILITY" | translate }}</span>   
    <img  class="pt-1" [src]="getIconPath('svg/accessibility-blue.svg')" />
  </button>
  @if (menuOpen) {
  <div
    #menuPanel
    id="a11y-menu"
    role="dialog"
    tabindex="-1"
    [attr.aria-label]="'HEADER.ACCESSIBILITY_MENU.HEADING' | translate"
    class="fixed left-2 right-2 top-16 z-20 max-h-[calc(100vh-5rem)] overflow-y-auto rounded-lg bg-white text-left shadow-2xl ring-1 ring-black/5 focus:outline-hidden md:ltr:absolute md:ltr:left-auto md:ltr:right-0 md:ltr:top-auto md:ltr:mt-3 md:ltr:w-[32rem] md:ltr:max-w-[90vw] md:ltr:max-h-[80vh] md:rtl:fixed md:rtl:left-auto md:rtl:right-2 md:rtl:top-16 md:rtl:mt-0 md:rtl:w-[32rem] md:rtl:max-w-[90vw] md:rtl:max-h-[80vh]"
    (click)="$event.stopPropagation()"
  >
    <div class="bg-dc-navy px-4 py-3 text-white">
      <div class="flex items-center justify-between gap-3">
        <p class="text-white!">
          {{ "HEADER.ACCESSIBILITY_MENU.HEADING" | translate }}
        </p>
        <button class="modal-x-button text-white! hover:text-white!" type="button" (click)="closeMenu()">
          <i class="fas fa-close"></i>
        </button>          
      </div>
    </div>
    <div class="flex flex-col gap-6 bg-gray-50 px-4 py-5 text-sm text-gray-700">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <!-- <span class="rounded-full bg-white px-4 py-1.5 text-xs font-semibold text-dc-navy shadow-sm">
          {{ languageLabel }}
        </span> -->
        <p class="text-xs text-gray-500">
          {{ "HEADER.ACCESSIBILITY_MENU.DESCRIPTION" | translate }}
        </p>
      </div>

      <div>
        <h3 class="text-xs font-semibold uppercase tracking-wide text-gray-500">
          {{ "HEADER.ACCESSIBILITY_MENU.CONTENT_ADJUSTMENTS" | translate }}
        </h3>
        <div class="mt-3 grid gap-3 md:grid-cols-2">
          <div class="a11y-card-control flex">
            <div class="a11y-card-header">
              <div class="a11y-card-icon">TT</div>
              <div>
                <p class="a11y-card-title">
                  {{ "HEADER.ACCESSIBILITY_MENU.TEXT_SIZE" | translate }}
                </p>
                <p class="a11y-card-subtitle">
                  {{
                    "HEADER.ACCESSIBILITY_MENU.TEXT_SIZE_VALUE"
                      | translate : { value: settings.fontScale }
                  }}
                </p>
              </div>
            </div>
            <div class="a11y-card-controls">
              <button
                type="button"
                class="a11y-round-btn"
                (click)="decreaseFont.emit()"
                [disabled]="settings.fontScale <= 80"
                [attr.aria-label]="
                  'HEADER.ACCESSIBILITY_MENU.DECREASE_TEXT' | translate
                "
              >
                −
              </button>
              <span class="a11y-card-value">{{ settings.fontScale }}%</span>
              <button
                type="button"
                class="a11y-round-btn"
                (click)="increaseFont.emit()"
                [disabled]="settings.fontScale >= 130"
                [attr.aria-label]="
                  'HEADER.ACCESSIBILITY_MENU.INCREASE_TEXT' | translate
                "
              >
                +
              </button>
            </div>
          </div>

          <div class="a11y-card-control">
            <div class="a11y-card-header">
              <div class="a11y-card-icon">|A|</div>
              <div>
                <p class="a11y-card-title">
                  {{ "HEADER.ACCESSIBILITY_MENU.TEXT_SPACING" | translate }}
                </p>
                <p class="a11y-card-subtitle">
                  {{
                    "HEADER.ACCESSIBILITY_MENU.TEXT_SPACING_LEVELS." +
                      settings.textSpacing | translate
                  }}
                </p>
              </div>
            </div>
            <div class="a11y-card-controls">
              <button
                type="button"
                class="a11y-round-btn"
                (click)="decreaseTextSpacing.emit()"
                [disabled]="settings.textSpacing === 'normal'"
                [attr.aria-label]="
                  'HEADER.ACCESSIBILITY_MENU.DECREASE_TEXT_SPACING' | translate
                "
              >
                −
              </button>
              <span class="a11y-card-value">
                {{
                  "HEADER.ACCESSIBILITY_MENU.TEXT_SPACING_LEVELS." +
                    settings.textSpacing | translate
                }}
              </span>
              <button
                type="button"
                class="a11y-round-btn"
                (click)="increaseTextSpacing.emit()"
                [disabled]="settings.textSpacing === 'large'"
                [attr.aria-label]="
                  'HEADER.ACCESSIBILITY_MENU.INCREASE_TEXT_SPACING' | translate
                "
              >
                +
              </button>
            </div>
          </div>

          <div class="a11y-card-control">
            <div class="a11y-card-header">
              <div class="a11y-card-icon">LS</div>
              <div>
                <p class="a11y-card-title">
                  {{ "HEADER.ACCESSIBILITY_MENU.LINE_SPACING" | translate }}
                </p>
                <p class="a11y-card-subtitle">
                  {{
                    "HEADER.ACCESSIBILITY_MENU.LINE_SPACING_LEVELS." +
                      settings.lineSpacing | translate
                  }}
                </p>
              </div>
            </div>
            <div class="a11y-card-controls">
              <button
                type="button"
                class="a11y-round-btn"
                (click)="decreaseLineSpacing.emit()"
                [disabled]="settings.lineSpacing === 'normal'"
                [attr.aria-label]="
                  'HEADER.ACCESSIBILITY_MENU.DECREASE_LINE_SPACING' | translate
                "
              >
                −
              </button>
              <span class="a11y-card-value">
                {{
                  "HEADER.ACCESSIBILITY_MENU.LINE_SPACING_LEVELS." +
                    settings.lineSpacing | translate
                }}
              </span>
              <button
                type="button"
                class="a11y-round-btn"
                (click)="increaseLineSpacing.emit()"
                [disabled]="settings.lineSpacing === 'large'"
                [attr.aria-label]="
                  'HEADER.ACCESSIBILITY_MENU.INCREASE_LINE_SPACING' | translate
                "
              >
                +
              </button>
            </div>
          </div>

          <button
            type="button"
            class="a11y-tile"
            [class.a11y-tile-active]="settings.underlineLinks"
            (click)="toggleUnderlineLinks.emit()"
            [attr.aria-pressed]="settings.underlineLinks"
          >
            <span class="a11y-tile-icon underline">T</span>
            <span class="a11y-tile-label">{{
              "HEADER.ACCESSIBILITY_MENU.UNDERLINE_LINKS" | translate
            }}</span>
          </button>

          <button
            type="button"
            class="a11y-tile"
            [class.a11y-tile-active]="settings.fontWeight === 'bold'"
            (click)="toggleFontWeight.emit()"
            [attr.aria-pressed]="settings.fontWeight === 'bold'"
          >
            <span class="a11y-tile-icon">B</span>
            <span class="a11y-tile-label">{{
              "HEADER.ACCESSIBILITY_MENU.FONT_WEIGHT" | translate
            }}</span>
          </button>
        </div>
      </div>

      <div>
        <h3 class="text-xs font-semibold uppercase tracking-wide text-gray-500">
          {{ "HEADER.ACCESSIBILITY_MENU.VISUAL_ADJUSTMENTS" | translate }}
        </h3>
        <div class="mt-3 grid gap-3 md:grid-cols-2">
          <button
            type="button"
            class="a11y-tile"
            [class.a11y-tile-active]="settings.highContrast"
            (click)="toggleHighContrast.emit()"
            [attr.aria-pressed]="settings.highContrast"
          >
            <span class="a11y-tile-icon">HC</span>
            <span class="a11y-tile-label">{{
              "HEADER.ACCESSIBILITY_MENU.HIGH_CONTRAST" | translate
            }}</span>
          </button>

          <button
            type="button"
            class="a11y-tile"
            [class.a11y-tile-active]="settings.grayscale"
            (click)="toggleGrayscale.emit()"
            [attr.aria-pressed]="settings.grayscale"
          >
            <span class="a11y-tile-icon">GS</span>
            <span class="a11y-tile-label">{{
              "HEADER.ACCESSIBILITY_MENU.GRAYSCALE" | translate
            }}</span>
          </button>

          <button
            type="button"
            class="a11y-tile"
            [class.a11y-tile-active]="settings.readingGuide"
            (click)="toggleReadingGuide.emit()"
            [attr.aria-pressed]="settings.readingGuide"
          >
            <span class="a11y-tile-icon">RG</span>
            <span class="a11y-tile-label">{{
              "HEADER.ACCESSIBILITY_MENU.READING_GUIDE" | translate
            }}</span>
          </button>

          <button
            type="button"
            class="a11y-tile"
            [class.a11y-tile-active]="settings.bigCursor"
            (click)="toggleBigCursor.emit()"
            [attr.aria-pressed]="settings.bigCursor"
          >
            <span class="a11y-tile-icon">CUR</span>
            <span class="a11y-tile-label">{{
              "HEADER.ACCESSIBILITY_MENU.BIG_CURSOR" | translate
            }}</span>
          </button>
        </div>
      </div>

      <div>
        <h3 class="text-xs font-semibold uppercase tracking-wide text-gray-500">
          {{ "HEADER.ACCESSIBILITY_MENU.ASSISTIVE_TOOLS" | translate }}
        </h3>
        <div class="mt-3 grid gap-3 md:grid-cols-2">
          <div class="a11y-card-control md:col-span-2">
            <div class="a11y-card-header">
              <div class="a11y-card-icon">SP</div>
              <div>
                <p class="a11y-card-title">
                  {{ "HEADER.ACCESSIBILITY_MENU.READ_TEXT" | translate }}
                </p>
                <p class="a11y-card-subtitle">
                  {{
                    (isSpeechSupported
                      ? "HEADER.ACCESSIBILITY_MENU.READ_TEXT_DESCRIPTION"
                      : "HEADER.ACCESSIBILITY_MENU.READ_TEXT_UNAVAILABLE"
                    ) | translate
                  }}
                </p>
              </div>
            </div>
            <div class="a11y-card-controls gap-2">
              <button
                type="button"
                class="a11y-pill-btn a11y-pill-btn-primary"
                (click)="startReading.emit()"
                [disabled]="!isSpeechSupported || isReading"
              >
                {{ "HEADER.ACCESSIBILITY_MENU.READ_TEXT_START" | translate }}
              </button>
              <button
                type="button"
                class="a11y-pill-btn a11y-pill-btn-outline"
                (click)="stopReading.emit()"
                [disabled]="!isSpeechSupported || !isReading"
              >
                {{ "HEADER.ACCESSIBILITY_MENU.READ_TEXT_STOP" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <app-button
        [label]="'HEADER.ACCESSIBILITY_MENU.RESET' | translate"
        [classesName]="'btn-edge-cut w-full'"
        (onBtnClick)="menuOpen = false; resetAccessibility.emit()"
      ></app-button>
    </div>
  </div>
  }
</div>
